import lang from '@/assets/images/home/lang.png'
import view from '@/assets/images/home/view.png'
import picAndCharAndVoic from '@/assets/images/home/picAndCharAndVoic.png'
import understand from '@/assets/images/home/understand.png'
import interactive from '@/assets/images/home/interactive.png'
import dispatch from '@/assets/images/home/dispatch.png'
import search from '@/assets/images/home/seach.png'
import code from '@/assets/images/home/code.png'
import konwledge from '@/assets/images/home/konwledge.svg'
import perceive from '@/assets/images/home/perceive.svg'
import signal from '@/assets/images/home/signal.svg'
import content from '@/assets/images/home/content.svg'
import threeD from '@/assets/images/home/threeD.png'

// 官网首页
export const CONTACT_US =
  'https://muzembn5g9.feishu.cn/share/base/form/shrcn9oq11nKoEKMGwbNPnEnMNf'

// 产品中心
export const TRAIN_PLATFORM = 'https://platform.wair.ac.cn/taichu/#/'
// export const CHAT_DIGITAL = 'https://metahuman-cds.wair.ac.cn/#/?metaman=azhe'
export const CHAT_DIGITAL =
  import.meta.env.VITE_APP_COMMON_BASE_URL + '/zdtc-api/metaman/callback'
export const CREATE_DIGITAL = 'https://metahuman-prod.wair.ac.cn/create/#/home'

export const navbarIndustry = [
  { label: '政务', key: '#government' },
  { label: '教育', key: '#platform' },
  { label: '医疗', key: '#medical' },
  { label: '工业', key: '#industrial' },
  { label: '国土资源', key: '#resource' },
  { label: '交通', key: '#traffic' },
  { label: '金融', key: '#financial' },
]

export const navbar = [
  {
    label: '首页',
    key: 'home',
  },
  {
    label: '产品中心',
    key: 'productCenter',
    menu: [
      {
        label: '紫东太初对话平台',
        anchor: 'prd_chat',
      },
      {
        label: '算力服务平台',
        anchor: 'prd_computing',
      },
      {
        label: '大模型训推平台',
        anchor: 'prd_train',
      },
      {
        label: '数字人',
        anchor: 'prd_digital',
      },
    ],
  },
  {
    label: '行业解决方案',
    key: 'industry',
    menu: [
      {
        label: '政务',
        anchor: 'sol_gov',
      },
      {
        label: '教育',
        anchor: 'sol_edu',
      },
      {
        label: '医疗',
        anchor: 'sol_med',
      },
      {
        label: '工业',
        anchor: 'prd_indu',
      },
      {
        label: '国土资源',
        anchor: 'prd_land',
      },
      {
        label: '交通',
        anchor: 'prd_traffic',
      },
      {
        label: '金融',
        anchor: 'prd_finance',
      },
    ],
  },
]
// 首页
export const capacityTab = [
  {
    label: '多模态能力',
    key: 'multiple',
    children: [
      {
        title: '语言能力',
        key: 'language',
        img: lang,
        describe:
          '中文推理能力达到GPT-4o的95%,中文写作能力相对于GPT-4o超出3%。支持128K长文本。',
      },
      {
        title: '视觉语言能力',
        key: 'visual',
        img: view,
        describe:
          '中文视觉对话能力相对于GPT-4o超出2%，OCR类能力相对于GPT-4o超出3%，视觉定位能力超越专有模型。',
      },
      {
        title: '图文音能力',
        key: 'imageText',
        img: picAndCharAndVoic,
        describe:
          '零样本语音情感识别能力达到领先水平,图文音混合理解能力相比Gemini-1.5-pro 超出6%。',
      },
    ],
  },
  {
    label: '智能体能力',
    key: 'agent',
    children: [
      {
        title: '理解能力',
        key: 'comprehend',
        img: understand,
        describe:
          '首次实现多模态复杂任务规划与智能求解，更接近人类的理解能力。',
      },
      {
        title: '交互能力',
        key: 'interaction',
        img: interactive,
        describe:
          '通过准确的多步任务拆解和高效的工具调用,支持跨模态信息协同合作,提升理解和交互能力。',
      },
      {
        title: '同步调度能力',
        key: 'scheduling',
        img: dispatch,
        describe:
          '在简单任务规划方面，超越gpt-4o 5%,在多模态复杂任务方面，首次突破图文音同步调度',
      },
    ],
  },
  {
    label: '多模态检索增强',
    key: 'multipleSeach',
    children: [
      {
        title: '多模态编码能力',
        key: 'coding',
        img: code,
        describe:
          '通过多模态统一编码，支持图像、文本查询。各模块协同配合，自适应调度，支持多种类型文档与提问。',
      },
      {
        title: '检索增强与溯源能力',
        key: 'retrieve',
        img: search,
        describe:
          '针对答案，支持多模态类内容精准溯源。针对问题，支持复杂查询的拆解与改写。',
      },
    ],
  },
]

export const doContent = [
  {
    title: '知识问答',
    img: konwledge,
    describe:
      '专属知识库和联网搜索实现大模型检索增强，有效缓解幻觉，加速知识学习，使得大模型更加实用和可信。',
  },
  {
    title: '多模态理解',
    img: perceive,
    describe:
      '关注图文音三模态数据之间的关联特性，支持图文问答、视觉定位、视觉指代、OCR问答、音乐理解。',
  },
  {
    title: '多模态内容生成',
    img: content,
    describe:
      '多种艺术风格的AI作画，精准控制绘画细节；文本指令可智能作曲生成音乐片段。',
  },
  {
    title: '3D理解',
    img: threeD,
    describe: '基于点云数据的3D场景理解和物体感知能力。',
  },
  {
    title: '信号分析',
    img: signal,
    describe:
      '支持雷达信号鉴别与知识交互，可借助模型快速掌握信号基本来源及参数等。',
  },
]
